'use strict';

require('vocabs')(
  exports,
  'http://www.w3.org/1999/02/22-rdf-syntax-ns#', 'rdf',
  ['first','rest','nil','type']
);
